export default __webpack_public_path__ + "static/favicon-894126329f6769253a7feb2881d8e71a.png";